<h1 class="heading" v-if="animated"><VueWriter :array="text" :typeSpeed="70" :eraseSpeed="50"></VueWriter></h1><h1 class="heading" v-else>{{text}}</h1>